import { render, staticRenderFns } from "./CorreoRespuesta.vue?vue&type=template&id=6d306e6c"
import script from "./CorreoRespuesta.vue?vue&type=script&lang=js"
export * from "./CorreoRespuesta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports